import { Skeleton } from '@shared/components/ui/shadcn';

export const OrderInformationSkeleton = () => {
  return (
    <div className="p-4 space-y-4 mb-6 pb-6 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4 border-b border-card-border">
      <div className="col-span-1 md:col-span-2">
        <Skeleton className="h-6 w-40 rounded-full mb-2 bg-hover-press" />
        <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
            <Skeleton className="h-10 w-full bg-hover-press" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-16 rounded-full bg-hover-press" />
            <Skeleton className="h-10 w-full bg-hover-press" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
            <Skeleton className="h-10 w-full bg-hover-press" />
          </div>
        </div>
      </div>
    </div>
  );
};
